export default __webpack_public_path__ + "static/media/asset-meteor.6e75f15a.png";